import ShowDown from 'showdown'

class StringHelper {
  static random (length = 8) {
    var text = ''
    var possible = 'ABCDEF0123456789' // GHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz
    for (var i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length))
    }
    return text
  }

  static isBlank (value) {
    if (value == null) return true
    if (typeof value === 'string') return value.length <= 0
    if (typeof value === 'number') return `${value}`.length <= 0
    console.error(`invalid isBlank check: ${value}`)
    return true
  }

  static replaceSpaceToPlus (name) {
    return name && name.replace(/\s/g, '+')
  }

  static showdown (content) {
    if (!content || typeof content !== 'string') return
    var converter = new ShowDown.Converter()
    var html = converter.makeHtml(content)
    return html
  }
}

export default StringHelper
